import {
  useStudent,
  useUser,
  useUserRole,
} from 'applications/GSP/shared/hooks/user';
import { UserRole } from 'applications/GSP/shared/types';
import { getFullName, getShortName } from 'applications/GSP/shared/utils/user';

const allowedRoles = [
  UserRole.Staff,
  UserRole.Admin,
  UserRole.NonTeachingStaff,
];

export const useStudentSectionUser = () => {
  const user = useUser();
  const student = useStudent();
  const userRole = useUserRole();
  const allowedUser = allowedRoles.includes(userRole) ? user : undefined;

  if (!student && !allowedUser) return null;

  const studentFullName = student ? getFullName(student) : '';
  const adminFullName = allowedUser ? getFullName(allowedUser) : '';
  const studentShortName = student ? getShortName(student) : '';
  const adminShortName = allowedUser ? getShortName(allowedUser) : '';

  const shortName = studentShortName || adminShortName;
  const fullName = studentFullName || adminFullName;
  const subCaption = student?.formGroupName || allowedUser?.emailAddress;
  const profilePictureUrl = student?.profilePictureUrl ?? undefined;

  return {
    shortName,
    fullName,
    subCaption,
    profilePictureUrl,
  };
};
